import { render, staticRenderFns } from "./ZhanhuiHytcBlock.vue?vue&type=template&id=18a50373&scoped=true"
import script from "./ZhanhuiHytcBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiHytcBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiHytcBlock.vue?vue&type=style&index=0&id=18a50373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a50373",
  null
  
)

export default component.exports